import axios from '../utils/axiosConfig';

export interface CardEditToken {
  _id: string;
  token: string;
  competition: string;
  club: { _id: string; name: string } | string;
  athletes: { _id: string; firstname: string; surname: string }[];
  label: string;
  createdBy: string;
  createdByRole: string;
  expiresAt: string;
  isRevoked: boolean;
  secondCardOnly: boolean;
  bypassDeadline: boolean;
  createdAt: string;
}

const cardTokenService = {
  createToken: async (params: {
    competitionId: string;
    clubId: string;
    athleteIds: string[];
    label?: string;
    durationDays?: number;
    secondCardOnly?: boolean;
    bypassDeadline?: boolean;
  }): Promise<CardEditToken> => {
    const response = await axios.post('/api/card-tokens', {
      competitionId: params.competitionId,
      clubId: params.clubId,
      athleteIds: params.athleteIds,
      label: params.label || '',
      durationDays: params.durationDays ?? 7,
      secondCardOnly: params.secondCardOnly ?? false,
      bypassDeadline: params.bypassDeadline ?? false
    });
    return response.data;
  },

  getTokens: async (competitionId: string, clubId?: string): Promise<CardEditToken[]> => {
    const params: Record<string, string> = { competitionId };
    if (clubId) params.clubId = clubId;
    const response = await axios.get('/api/card-tokens', { params });
    return response.data;
  },

  revokeToken: async (tokenId: string): Promise<void> => {
    await axios.delete(`/api/card-tokens/${tokenId}`);
  }
};

export default cardTokenService;
